<div class="container">
  <div class="header">
    <div class="breadcrumb">{{ labels.controlPanel }} / {{  productId ? labels.editProduct : labels.addProduct }}</div>
    <div class="title">{{  productId ? labels.editProduct : labels.addProduct }}</div>
  </div>
  <div class="divider"></div>
  <div class="form">
    <div class="form-container" [class.loading-active]="loading">
      <app-product-stepper #stepper [formValid]="productForm.valid" [isEditing]="isEditing">
        <ng-template appProductStep *ngIf="!loading">
          <app-product-form [form]="productForm" [productFamilies]="productFamilies" [labels]="labels" [product]="product" (isEditing)="onEditing($event)"></app-product-form>
        </ng-template>
        <ng-template appProductStep *ngIf="!loading">
          <app-product-summary [product]="productSummary" [labels]="labels"></app-product-summary>
        </ng-template>
      </app-product-stepper>
      <div *ngIf="loading" class="loading-overlay">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    </div>
  </div>
  <div class="footer">
    <button mat-stroked-button color="primary" (click)="goBack()">
        <nb-icon icon="close-outline"></nb-icon>{{ labels.cancel }}
      </button>
      <div class="back-next-button">
          <button mat-stroked-button color="primary" (click)="stepper.prev()" *ngIf="stepper.currentStep === 1">
            <nb-icon icon="arrow-back-outline"></nb-icon>{{ labels.back }}
          </button>
          <button mat-flat-button color="primary" [disabled]="productForm.invalid || isEditing" (click)="stepper.next()" *ngIf="stepper.currentStep === 0">
            <nb-icon icon="arrow-forward-outline"></nb-icon> {{ labels.next }}
          </button>
          <button mat-flat-button color="primary" [disabled]="productForm.invalid" (click)="saveProduct()" *ngIf="stepper.currentStep === 1">
            <nb-icon icon="checkmark-outline"></nb-icon> {{ productId? labels.update : labels.create }}
          </button>
      </div>
  </div>
</div>
